module.exports = __webpack_public_path__ + "static/media/hall-P5.65036f70.svg";